import React, { useEffect, useState, } from 'react';
import '../admin.list.scss';
import { useTranslation, } from 'react-i18next';
import { useNavigate, } from 'react-router-dom';
import { ColumnsType, SorterResult, } from 'antd/lib/table/interface';
import { IPreviewCannedAnswer, PermissionEnum, CrudEnum, TCannedAnswerSortableListCol, } from 'atlas-shared';
import { Table, } from 'antd';
import { AdminListPageHeader, ListPageEmpty, } from '@Components';
import { IWithListProps, IWithListSorterProps, withList, } from '@Hocs/with.list';
import { useAbilities, useAuth, useCannedAnswers, useOrganizations, } from '@Hooks';
import { CannedAnswerListColumns, } from '@Utils';
import { IAuth, } from '@Store';

const CannedAnswerList = ({ filters, filtersCount, hasFilters, sorter, pagination, setQueryParams, resetQueryParams, }: IWithListProps<IPreviewCannedAnswer, TCannedAnswerSortableListCol>) => {
  const { t, } = useTranslation();
  const navigate = useNavigate();
  const auth: IAuth = useAuth();
  const canned_answers = useCannedAnswers();
  const abilities = useAbilities();
  const [loading, setLoading, ] = useState<boolean>(true);
  const [rows, setRows, ] = useState<Array<any>>([]);
  const organizations = useOrganizations();
  
  const [showDeleted, setShowDeleted, ] = useState(false);
  const [deletedCount, setDeletedCount, ] = useState<number>(0);
  
  useEffect(() => {
    if (!canned_answers.loaded)
      return;
      
    setLoading(false);
    setRows((!showDeleted ? canned_answers.canned_answers.filter(p => !p.deleted_at) : canned_answers.canned_answers || []).map(row => ({ ...row, key: row.id, })));
    setDeletedCount(canned_answers.canned_answers.filter(canned_answer => !!canned_answer.deleted_at).length);
  }, [canned_answers, showDeleted, ]);

  const columns: ColumnsType<IPreviewCannedAnswer> = React.useMemo(() => {
    return CannedAnswerListColumns(t, navigate, showDeleted, organizations, abilities, auth, [], filters, sorter);
  }, [t, navigate, showDeleted, organizations, abilities, auth, filters, sorter, ]);

  return <div className='admin-list-view'>
    <AdminListPageHeader 
      t={t}
      title={t('CANNED_ANSWERS')}
      filtersCount={filtersCount}
      reset={() => resetQueryParams()}
      deleted={[showDeleted, setShowDeleted, ]} deletedCount={deletedCount}
      addBtn={abilities.canImplicit(null, CrudEnum.Insert, PermissionEnum.CannedAnswer) ? { callback: () => navigate('/admin/canned_answer/add'), } : undefined} 
    />
    <div className='table-wrp'>
      <Table
        key={loading ? 1 : 0}
        columns={columns}
        dataSource={rows}
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
        }}
        onChange={(pagination, filters, _sorter) => {
          const sorter: Array<SorterResult<any>> = Array.isArray(_sorter) ? _sorter : _sorter?.columnKey ? [_sorter, ] : [];

          setQueryParams({
            pagination: { current: pagination.current as number, pageSize: pagination.pageSize as number, },
            filters: Object.fromEntries(Object.entries(filters).filter(([key, value, ]) => value !== null)),
            sorter: sorter
              .filter(s => !!s.order)
              .map(s => ({ column: s.columnKey as TCannedAnswerSortableListCol, order: s.order as IWithListSorterProps<IPreviewCannedAnswer, TCannedAnswerSortableListCol>['order'], })),
          });
        }}
        locale={{
          emptyText: <ListPageEmpty t={t} hasFilters={hasFilters} hasRows={!!rows.length} reset={() => resetQueryParams()} />,
        }}
      />
    </div>
  </div>;
};

export const CannedAnswerListView = React.memo(withList<IPreviewCannedAnswer, TCannedAnswerSortableListCol>(CannedAnswerList, {
  filters: {},
  sorter: [{ column: 'created_at', order: 'descend', }, ],
  pagination: { current: 1, pageSize: 10, },
}));
